import { isAutomatedMonitorsTest, isContentTest } from '../../utils/common';

const testTypeFilterRenderer = (value: string) =>
  isAutomatedMonitorsTest(value)
    ? 'automated'
    : isContentTest(value)
    ? 'metric anomalies'
    : value;

export default testTypeFilterRenderer;
